import styled from 'styled-components';
import { Styling, Colors } from '../../../constants';

export const ProductMenuContainer = styled.div`
  margin-top: ${Styling.DEFAULT_SPACING_HALVED}px;
  * {
    color: ${Colors.WHITE_100};
  }
  svg {
    font-size: 1.25rem;
    margin-top: -${Styling.DEFAULT_SPACING_HALVED}px;
  }
`;

export const ProductName = styled.span`
  margin-left: ${Styling.DEFAULT_SPACING}px;
  font-size: 20px;
  user-select: none;
  text-transform: uppercase;
`;
